import { getLangCode, language } from "../config";

export const getStripeLocale = () => {
  return language.stripeLocales[getLangCode()] || language.default;
};
